const getCart = async () => {
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch cart: ${response.status}`);
    }

    const cart = await response.json();
    return cart;
  } catch (err) {
    console.error('Error fetching cart:', err);
    return null;
  }
};

export default getCart;
